import React, { memo, useCallback, useMemo } from 'react';
import { useObservable } from '@core/utils/hooks/rxjs';
import { PayablesListBloc } from './PayablesListBloc';
import { useBloc } from '@core/utils/bloc';
import { formControl, FormDataType, formGroup } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { PaymentTypeStatus } from '@business/entities/tm';
import { TimeMaterialService } from '@business/services/time_material_service';
import { Tabs, TabsMapping } from '@modules/common';
import { PayablesListViaType } from './PayablesListViaType';

export const definePayablesFilterForm = () => {
  return formGroup({
    providerId: formControl<string>({ placeholder: 'Select Vendor' }),
  });
};

export type PayablesFilterFormData = FormDataType<typeof definePayablesFilterForm>;
export type PayablesFilterFormType = ReturnType<typeof definePayablesFilterForm>;

export const PayablesList = memo(() => {
  const bloc = useBloc(PayablesListBloc);
  const form = useMemo(() => definePayablesFilterForm(), []);
  const formValue = useObservable(form.value$);

  const filterTabs: TabsMapping[] = useMemo(() => {
    const tabs = [
      {
        title: 'All',
        component: PayablesListViaType,
        props: { type: 'all', bloc },
        visible: true,
      },
    ];

    for (const paymentType of PaymentTypeStatus) {
      tabs.push({
        title: TimeMaterialService.getPaymentTypeStatusTitle(paymentType),
        component: PayablesListViaType,
        props: { type: paymentType, bloc },
        visible: true,
      });
    }

    return tabs;
  }, []);

  const handleTabChange = useCallback(
    (index: number) => {
      const paymentTypeStatus = filterTabs[index]?.props?.type || 'all';
      bloc.paginated.patchQuery({ ...formValue, paymentTypeStatus, page: 1 }).subscribe();
    },
    [filterTabs, formValue],
  );
  return (
    <CBody>
      <Tabs tabs={filterTabs} onChange={handleTabChange} pills={true} simple={true} />
    </CBody>
  );
});
